// extracted by mini-css-extract-plugin
export default {"container":"Metamask_container__xVZoV","button":"Metamask_button__ZsDrs"};